"use client";
import { profilePageFilterItems } from "../utils/fetch";
import MainContainerAdSlot from "@/features/Ads/components/MainContainerAdSlot";
import { BadgeProgress, FlashcardSet, Folder, Note, UserDetails } from "@knowt/syncing/graphql/schema";
import { LocalUser } from "@knowt/syncing/hooks/user/types";
import { InnerContainer, MainContainer } from "@/components/Containers";
import { unstable_serialize } from "swr";
import { resolveBadgeProgressSWRKey } from "@knowt/syncing/hooks/gamification/badges/useBadges";
import { StableSWRKeys } from "@knowt/syncing/hooks/swr/swr";
import SWRConfig from "@/components/ClientSWRConfig";
import ProfileSideCard from "./components/ProfileSideCard";
import ProfileMainContent from "./components/ProfileMainContent";
import styles from "./profilepage.module.css";
import { spacing } from "@/utils/spacing";
import br from "@/styles/breakpoints.module.css";

type ProfilePageProps = {
    userInfo: UserDetails;
    serverUser: LocalUser;
    notesResult: { notes: Note[]; total: number };
    flashcardSetsResult: { flashcardSets: FlashcardSet[]; total: number };
    foldersResult: { folders: Folder[]; total: number };
    serverBadgeProgress: BadgeProgress[];
};

const ProfilePage = ({
    serverUser,
    userInfo,
    notesResult,
    flashcardSetsResult,
    foldersResult,
    serverBadgeProgress,
}: ProfilePageProps) => {
    const isOwner = userInfo.ID === serverUser.user?.ID;

    const { notes } = notesResult;
    const { flashcardSets } = flashcardSetsResult;
    const { folders } = foldersResult;

    const items = profilePageFilterItems([...notes, ...flashcardSets], folders);

    return (
        <SWRConfig
            value={{
                fallback: {
                    [StableSWRKeys.USER]: serverUser,
                    [unstable_serialize(resolveBadgeProgressSWRKey(userInfo.ID || ""))]: serverBadgeProgress,
                },
            }}>
            <MainContainer style={{ marginBlock: "2rem 0rem", marginInline: "4rem 4rem", gap: spacing.XS_2 }}>
                <InnerContainer
                    style={{ flexDirection: "row", gap: `${spacing.MD} ${spacing.MD_S}` }}
                    className={br.lgDownColumnReverse}>
                    <ProfileSideCard
                        isOwner={isOwner}
                        userInfo={userInfo}
                        className={styles.brProfileXlPositionStatic}
                        style={{
                            flex: 1,
                            width: "100%",
                            alignSelf: "flex-start",
                            position: "sticky",
                            maxWidth: "35rem",
                            top: "calc(var(--navbar-height) + 2rem)",
                        }}
                    />
                    <ProfileMainContent userInfo={userInfo} isOwner={isOwner} items={items} folders={folders} />
                </InnerContainer>
                <MainContainerAdSlot {...serverUser} />
            </MainContainer>
        </SWRConfig>
    );
};

export default ProfilePage;
